module.exports = __webpack_public_path__ + "static/img/rz(10).28f27208.jpg";